// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V22H2V2ZM13 5.41421V11.5858L20 18.5858V12.4142L13 5.41421ZM20 9.58579V4H14.4142L20 9.58579ZM18.5858 20L13 14.4142V20H18.5858Z"}}]};

const WindowFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'window-filled',
    ref,
    icon: element,
  },
));

WindowFilledIcon.displayName = 'WindowFilledIcon';

export default WindowFilledIcon;
